var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label-width": "0"
    }
  }, [_c('el-divider', {
    staticClass: "custom-divider"
  }, [_vm._v(_vm._s(_vm.i18nt('designer.setting.inputButton')))])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.appendButton')
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.optionModel.appendButton),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "appendButton", $$v)
      },
      expression: "optionModel.appendButton"
    }
  })], 1)], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b5e62c78","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-designer/setting-panel/property-editor/appendButton-editor.vue
// module id = null
// module chunks = 